import trackEvent from '../trackEvent';

export const signOffClicked = (traits = {}) => {
  trackEvent('Sign Off - Clicked', traits, true);
};

export const signOffComplete = (traits = {}) => {
  trackEvent('Sign Off - Complete', traits, true);
};
